module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ordermanagement-wrap"
  }, [_c('cIndex', {
    ref: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "ordermanagement"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowNull),
      expression: "isShowNull"
    }],
    staticClass: "ordermanagement-null"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Group.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无订单")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowOrderList),
      expression: "isShowOrderList"
    }],
    staticClass: "ordermanagement-list"
  }, [_c('div', {
    staticStyle: {
      "height": ".3rem"
    }
  }), _vm._v(" "), _vm._l((_vm.getOrserList), function(item, index) {
    return _c('div', {
      staticClass: "list-content"
    }, [_c('div', {
      staticClass: "div"
    }, [_c('h4', [_c('b', [_vm._v("套餐类型 : ")]), _c('span', [_vm._v(_vm._s(item.tc))])]), _vm._v(" "), _c('div', [(item.orderstatus == 1) ? _c('em', [_c('b', [_vm._v("订单状态 ：")]), _vm._v("待付款")]) : _vm._e(), _vm._v(" "), (item.orderstatus == 2) ? _c('em', [_c('b', [_vm._v("订单状态 ：")]), _vm._v("已支付")]) : _vm._e(), _vm._v(" "), (item.orderstatus == 3) ? _c('em', [_c('b', [_vm._v("订单状态 ：")]), _vm._v("已取消")]) : _vm._e(), _vm._v(" "), (item.orderstatus == 4) ? _c('em', [_c('b', [_vm._v("订单状态 ：")]), _vm._v("已删除")]) : _vm._e(), _vm._v(" "), (item.orderstatus == '3' && item.cpstatus == '0') ? _c('p', {
      staticClass: "button-cancel",
      on: {
        "click": function($event) {
          _vm.buttonCancel(item.tc)
        }
      }
    }, [_vm._v("再次购买")]) : _vm._e(), _vm._v(" "), (item.orderstatus == '1' && item.cpstatus == '0') ? _c('p', {
      staticClass: "button-noOrder",
      on: {
        "click": function($event) {
          _vm.buttonOrder(item.ordernumber, item.id)
        }
      }
    }, [_vm._v("立即支付")]) : _vm._e(), _vm._v(" "), ((item.orderstatus == '2' || item.orderstatus == '3') && item.cpstatus > '0') ? _c('p', {
      staticClass: "button-order",
      on: {
        "click": function($event) {
          _vm.buttonLook(item.id, item.pid, item.bid)
        }
      }
    }, [_vm._v("查看报告")]) : _vm._e(), _vm._v(" "), (item.orderstatus == '2' && item.cpstatus == '0') ? _c('p', {
      staticClass: "button-evaluation",
      on: {
        "click": function($event) {
          _vm.buttonEvaluation(item.id)
        }
      }
    }, [_vm._v("继续检测")]) : _vm._e()])]), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("订单日期 : ")]), _c('span', [_vm._v(_vm._s(item.createtime))])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("订单号 : ")]), _c('span', [_vm._v(_vm._s(item.ordernumber))])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("检测状态 : ")]), (item.cpstatus == '0') ? _c('span', [_vm._v("未检测")]) : _vm._e(), (item.cpstatus > '0') ? _c('span', [_vm._v("已检测")]) : _vm._e()]), _vm._v(" "), (item.orderstatus == 2 || item.orderstatus == 4) ? _c('li', [_c('b', [_vm._v("支付方式 : ")]), (item.payType == 1) ? _c('span', [_vm._v("支付宝")]) : _vm._e(), (item.payType == '2') ? _c('span', [_vm._v("微信")]) : _vm._e(), _vm._v(" "), (item.payType == '3') ? _c('span', [_vm._v("电子卡")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.orderstatus == 2 && (item.payType == 1 || item.payType == 2)) ? _c('li', [_c('b', [_vm._v("实际支付价格 : ")]), _c('em', [_vm._v("￥" + _vm._s(item.tcprice))])]) : _vm._e(), _vm._v(" "), (item.orderstatus == 1) ? _c('li', [_c('b', [_vm._v("需付款: ")]), _c('em', [_vm._v("￥" + _vm._s(item.tcprice))])]) : _vm._e(), _vm._v(" "), (item.orderstatus == 3) ? _c('li', [_c('b', [_vm._v("需付款: ")]), _c('em', [_vm._v("￥" + _vm._s(item.tcprice))])]) : _vm._e(), _vm._v(" "), (item.orderstatus == 4) ? _c('li', [_c('b', [_vm._v("需付款: ")]), _c('em', [_vm._v("￥" + _vm._s(item.tcprice))])]) : _vm._e(), _vm._v(" "), (item.orderstatus == 2 && item.payType == 3) ? _c('li', [_c('b', [_vm._v("实际支付价格: ")]), _c('em', [_vm._v("￥0.00")])]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "el-pagination__total"
  }, [_vm._v("共 "), _c('span', [_vm._v(_vm._s(_vm.getPages))]), _vm._v(" 页")]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "page-size": _vm.pageSize,
      "total": _vm.getTotal,
      "layout": "prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("确定")])], 1)], 2)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "myfroms"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79b91b97","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ordermanagement.vue
// module id = 764
// module chunks = 1